import React, { useEffect, useState } from 'react'
import '../../scss/pages/Employee helpdesk/employeeHelpdesk.scss';
import { Backdrop, Box, CircularProgress, Tab, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import OpenRequest from './Open Request/OpenRequest';
import ResolvedRequest from './Resolved Request/ResolvedRequest';
import { GET_EMPLOYEE_TICKETS } from '../../sagas/type';
import { getLocalStoreString } from '../../utils/Helper';
import { generateNumRandomId } from '../../components/common/GenerateRandomId/GenerateRandomId';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`
    };
}
function EmployeeHelpdesk() {
    const dispatch = useDispatch()
    const [value, setValue] = useState(0);
    const [loader, setLoader] = useState(false)
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getEmployeeTicketData = () => {

        const EmployeeID = getLocalStoreString('EmployeeId');
        const TenantId = getLocalStoreString("CompanyID");
        const randomId = generateNumRandomId(8);
        const reqGetTickets = {
            traceId: randomId,
            employeeId: EmployeeID,
            companyId: TenantId,
        }
        dispatch({
            type: GET_EMPLOYEE_TICKETS,
            payload: reqGetTickets,
            setLoader: setLoader,
        })
    }

    window.addEventListener('employeeDetailsFetch', () => {
        setLoader(true)
        getEmployeeTicketData();
    })

    useEffect(() => {
        setTimeout(() => {
            getEmployeeTicketData()
        }, 2000)
    }, [])

    return (
        <div className='Employee-helpdesk-Container' >
            <div className='Employee-helpdesk-Container_header'>
                <div className='Employee-helpdesk-Container_header_head-height'>
                    <span className='Employee-helpdesk-Container_header_head-height_content'>Service Desk</span>
                </div>
            </div>
            <div className='Employee-helpdesk-Container_tabs-Container'>
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="Open" {...a11yProps(0)} style={value == 0 ? { color: 'black', padding: '1px', background: '#FFFFFF', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: '10px', fontFamily: "'Noto Sans', sans-serif" } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", padding: '1px', background: 'rgba(255, 255, 255, 0.1)', fontWeight: 500, fontSize: '10px', borderRadius: '40px', fontFamily: "'Noto Sans', sans-serif" }} />
                    <Tab label="Resolved" {...a11yProps(1)} style={value == 1 ? { color: 'black', padding: '1px', background: '#FFFFFF', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: '10px', fontFamily: "'Noto Sans', sans-serif" } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", padding: '1px', background: 'rgba(255, 255, 255, 0.1)', fontWeight: 500, fontSize: '10px', borderRadius: '40px', fontFamily: "'Noto Sans', sans-serif" }} />
                </Tabs>
            </div>
            <TabPanel value={value} index={0}>
                <OpenRequest />
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loader}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <ResolvedRequest />
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loader}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </TabPanel>
        </div >
    )
}

export default EmployeeHelpdesk;